export default "__VITE_ASSET__CqEFVo_M__"